<template>
  <div class="offcanvas-body">
    <div class="h-100 flex-column d-flex align-items-center">
      <p class="text-paragraph text-center justify-self-start">
        Altere sua foto clicando na imagem abaixo
      </p>
      <div class="h-100 d-flex align-items-center">
        <AvatarUploader
          :avatar="avatar"
          :uploading="uploading"
          @onAvatarUploaded="onAvatarUploaded"
          :placeholder="placeholder"
        />
      </div>
      <Button
        fullWidth
        label="Concluir"
        @onClick="updateProfileImage"
        :loading="submitting"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";
import { useSyncSession } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);

const submitting = ref(false);
const uploading = ref(false);
const avatar = ref("");
const file = ref<any>(null);

const placeholder = computed(() =>
  session.value?.gender === "female"
    ? require("@/assets/img/avatars/1.png")
    : require("@/assets/img/avatars/2.png"),
);

onMounted(() => {
  avatar.value = sessionStore.session?.formatted_profile_image?.uri ?? "";
});

const { mutateAsync: updateUser } = useUpdateUser();
const { mutateAsync: syncSessionMutate } = useSyncSession();

async function onAvatarUploaded(event: any) {
  try {
    uploading.value = true;
    avatar.value = event.base64;
    file.value = event.file;
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
}

async function updateProfileImage() {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, profile_image: file.value });
    await syncSessionMutate();
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
}
</script>
